import { Text } from '@nike/eds';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setNposErrors } from '../../../../../redux/actions';
import { isValidEmail } from '../../../../../utils/ej-utils';
import FilterRow, { FilterGroup } from '../../reusable/Layout';
import TextInput from '../../reusable/TextInput/TextInput';

const lodash = require('lodash');

const TRANSACTION_INFO_FILEDS = [
  { id: 'transactionNo', placeholder: 'RL_TransactionNo2', type: 'number' },
  { id: 'orderId', placeholder: 'OrderId' },
  { id: 'originalTransactionNo', placeholder: 'RL_OriginalTransactionNo', type: 'number' },
  { id: 'tillNo', placeholder: 'RL_TillNo' },
  {
    id: 'emailId',
    placeholder: 'RL_ContactEmail',
    validator: () => {

    }
  },
  { id: 'transactionUuid', placeholder: 'RL_TransactionUUID' },
];

const TransactionInformation = ({ onFilterValueChange, translations }) => {
  const nposFilters = useSelector((state) => state.nposFilters);
  const nposErrors = useSelector((state) => state.nposErrors);

  const { emailId } = nposFilters;
  const groupedFields = lodash.chunk(TRANSACTION_INFO_FILEDS, 2);

  const dispatch = useDispatch();

  useEffect(() => {
    const getError = () => {
      if (emailId) {
        return isValidEmail(emailId) ? null : translations.RL_ErrInvalidEmail;
      }
      return null;
    };

    dispatch(setNposErrors({
      emailId: getError(),
    }));
  }, [emailId, translations, dispatch]);

  return (
    <FilterGroup>
      <Text className="filter-name">{translations.RL_TransactionInformation}</Text>
      {groupedFields.map((fields) => (
        <div
          key={`${fields[0]?.id}_${fields[1]?.id}`}
          className="d-sm-flx flx-dir-sm-r"
          style={{ gap: '12px' }}
        >
          {fields.map(({ id, placeholder, type }) => (
            <FilterRow key={id}>
              <TextInput
                data-testid={`transaction-info-${id}-input`}
                errorMessage={nposErrors[id]}
                hasErrors={!!nposErrors[id]}
                id={id}
                label={translations[placeholder]}
                placeholder={translations[placeholder]}
                style={{ minWidth: '250px' }}
                type={type || 'text'}
                value={nposFilters[id]}
                onChange={onFilterValueChange}
                onClear={() => onFilterValueChange({ target: { id, value: '' } })}
              />
            </FilterRow>
          ))}
        </div>
      ))}
    </FilterGroup>
  );
};

TransactionInformation.propTypes = {
  onFilterValueChange: PropTypes.func.isRequired,
  translations: PropTypes.shape().isRequired,
};

export default TransactionInformation;
